import React from "react";

import Layout from "../../Layout/Layout";
import VendorBanner from "./VendorBanner";
import VendorApp from "./VendorApp";
import Testimonial from "./../Home/Testimonial";
import VendorOffer from "./VendorOffer";
import VendorCommunity from "./VendorCommunity";
import ServiceList from "./../Home/ServiceList";
import MatterialList from "./../Home/MatterialList";

const VendorHome = () => {
  return (
    <Layout>
      <VendorBanner />

      <ServiceList />

      {/* <BannerQuotes /> */}
      <MatterialList />
      <div className="container-fluid  ">
        <VendorApp />
        <VendorOffer />
        {/* <VendorCommunity /> */}
        <Testimonial />
      </div>
    </Layout>
  );
};

export default VendorHome;
